var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.hasAccess)?_c('div',[_c('page-content',[_c('messaging-settings-panel',{attrs:{"show-domain-settings":false}})],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }